module.exports = __webpack_public_path__ + "nigeria.svg?0f7ee78391af03ce0e305af811ee1b39";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/nigeria.svg
// module id = 249
// module chunks = 10